(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wb-bundle-builder')) {
    customElements.define('wb-bundle-builder', class WbBundleBuilder extends HTMLElement {
      connectedCallback() {
        this.minimumItems = Number(this.dataset.minimumItems || 3);
        this.afterAdd = this.dataset.afterAdd || 'cart';
        this.selected = new Map();
        this.buttons = Array.from(this.querySelectorAll('[data-wb-bundle-select]'));
        this.decrementButtons = Array.from(this.querySelectorAll('[data-wb-bundle-decrement]'));
        this.addButton = this.querySelector('[data-wb-bundle-add]');
        this.addLabel = this.querySelector('[data-wb-bundle-add-label]');
        this.progress = this.querySelector('[data-wb-bundle-progress]');
        this.selectedList = this.querySelector('[data-wb-bundle-selected]');
        this.emptyState = this.querySelector('[data-wb-bundle-empty]');
        this.message = this.querySelector('[data-wb-bundle-message]');
        this.defaultAddText = this.addLabel?.textContent || 'Add bundle to cart';

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.toggleProduct(button));
        });

        this.decrementButtons.forEach((button) => {
          button.addEventListener('click', () => this.removeItem(button.dataset.variantId));
        });

        this.addButton?.addEventListener('click', () => this.addToCart());
        this.render();
      }

      toggleProduct(button) {
        if (button.disabled) return;

        const variantId = button.dataset.variantId;
        if (this.selected.has(variantId)) {
          const item = this.selected.get(variantId);
          item.quantity += 1;
        } else {
          this.selected.set(variantId, {
            id: variantId,
            title: button.dataset.title,
            price: button.dataset.price,
            quantity: 1
          });
        }

        button.setAttribute('aria-pressed', 'true');
        this.render();
      }

      getSelectedCount() {
        return Array.from(this.selected.values()).reduce((total, item) => total + item.quantity, 0);
      }

      render() {
        const count = this.getSelectedCount();
        const remaining = Math.max(this.minimumItems - count, 0);

        if (this.progress) {
          this.progress.textContent = remaining > 0
            ? `Choose ${remaining} more ${remaining === 1 ? 'item' : 'items'}`
            : `${count} selected`;
        }

        if (this.addButton) {
          this.addButton.disabled = count < this.minimumItems;
        }

        if (this.addLabel) {
          this.addLabel.textContent = count < this.minimumItems
            ? `Select ${this.minimumItems} items`
            : this.defaultAddText;
        }

        if (this.emptyState) {
          this.emptyState.hidden = count > 0;
        }

        if (this.selectedList) {
          this.selectedList.innerHTML = '';
          this.selected.forEach((item) => {
            const li = document.createElement('li');
            const label = document.createElement('span');
            const removeButton = document.createElement('button');
            li.className = 'wb-bundle-builder__selected-item';
            const quantityText = item.quantity > 1 ? ` × ${item.quantity}` : '';
            label.textContent = `${item.title}${quantityText}`;
            removeButton.type = 'button';
            removeButton.className = 'wb-bundle-builder__remove';
            removeButton.setAttribute('aria-label', `Remove one ${item.title}`);
            removeButton.textContent = '×';
            removeButton.addEventListener('click', () => this.removeItem(item.id));
            li.append(label, removeButton);
            this.selectedList.appendChild(li);
          });
        }

        this.buttons.forEach((button) => {
          const item = this.selected.get(button.dataset.variantId);
          const quantity = button.querySelector('[data-wb-bundle-quantity]');
          const decrement = this.querySelector(`[data-wb-bundle-decrement][data-variant-id="${button.dataset.variantId}"]`);
          button.setAttribute('aria-pressed', item ? 'true' : 'false');

          if (quantity) {
            quantity.hidden = !item;
            quantity.textContent = item ? `×${item.quantity}` : '';
          }

          if (decrement) {
            decrement.hidden = !item;
            decrement.disabled = !item;
          }
        });
      }

      removeItem(variantId) {
        const item = this.selected.get(variantId);
        if (!item) return;

        item.quantity -= 1;
        if (item.quantity <= 0) {
          this.selected.delete(variantId);
        }

        this.render();
      }

      async addToCart() {
        if (!this.addButton || this.getSelectedCount() < this.minimumItems) return;

        this.addButton.classList.add('loading');
        this.addButton.disabled = true;
        this.setMessage('');

        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const items = Array.from(this.selected.values()).map((item) => ({
          id: Number(item.id),
          quantity: item.quantity
        }));
        const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : ['cart-icon-bubble'];
        const body = {
          items,
          sections: [...new Set(sections)],
          sections_url: window.location.pathname
        };

        try {
          const baseAddUrl = window.routes?.cart_add_url || '/cart/add';
          const addUrl = baseAddUrl.endsWith('.js') ? baseAddUrl : `${baseAddUrl}.js`;
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
          const responseText = await response.text();
          let parsedState = null;

          try {
            parsedState = JSON.parse(responseText);
          } catch (error) {
            if (!response.ok) throw error;

            if (cartDrawer && this.afterAdd === 'drawer') {
              await customElements.whenDefined('cart-drawer');
              cartDrawer.init?.();
              cartDrawer.reload?.();
              setTimeout(() => cartDrawer.open?.(), 150);
              this.setMessage('Added. Your bundle is waiting in the cart.');
              return;
            }

            window.location.href = this.dataset.cartUrl || '/cart';
            return;
          }

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || 'Unable to add this bundle.');
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'wb-bundle-builder',
              cartData: parsedState
            });
          }

          if (this.afterAdd === 'checkout') {
            window.location.href = this.dataset.checkoutUrl || '/checkout';
            return;
          }

          if (cartDrawer && this.afterAdd === 'drawer') {
            await customElements.whenDefined('cart-drawer');
            cartDrawer.init?.();
            cartDrawer.renderContents(parsedState);
          } else if (cartNotification && this.afterAdd === 'notification') {
            await customElements.whenDefined('cart-notification');
            cartNotification.renderContents(parsedState);
          } else {
            window.location.href = this.dataset.cartUrl || '/cart';
          }

          this.setMessage('Added. Your bundle is waiting in the cart.');
        } catch (error) {
          this.setMessage(error.message || 'Unable to add this bundle. Please try again.');
          this.addButton.disabled = false;
        } finally {
          this.addButton.classList.remove('loading');
          this.render();
        }
      }

      setMessage(message) {
        if (this.message) this.message.textContent = message;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
